export default {
  yAxis: [{
    type: 'category',
    axisLine: {
      show: false //坐标线
    },
    axisTick: {
      show: false //小横线
    },
    axisLabel: {
      color: '#fff', //坐标轴字颜色
      formatter(value) {
        if (value >= 10000) {
          return `${(value / 10000).toLocaleString()}万`;
        } 
        return value.toLocaleString();
        
      },
    },
    data: ['河南', '上海', '湖南', '福建', '广东', '河北', '天津', '山西', '陕西', '甘肃', '宁夏', '青海', '新疆', '江苏', '安徽', '湖北', '浙江', '江西', '吉林', '内蒙古'],
  }, {
    type: 'category',
    inverse: true,
    axisTick: 'none',
    axisLine: 'none',
    show: true,
    axisLabel: {
      // textStyle: {
      //   color: '#ffffff',
      //   fontSize: '12',
      //   align: 'right'
      // },
      formatter(value) {
        // if (value >= 10000) {
        //   return `${(value / 10000).toLocaleString()}万`;
        // } 
        return value.toLocaleString();
      },
    },
    data: [1269, 963, 942, 653, 596, 562, 440, 421, 386, 363, 352, 256, 220, 173, 142, 86, 65, 45, 32, 10]
  }],
  xAxis: {
    show: false,
  },
  grid: {
    top: '1%',
    right: '15%',
    left: '50',
    bottom: '10' //图表尺寸大小
  },
  series: [{
    /* data: [120, 200, 150, 80, 70, 110, 130], */
    type: 'bar',
    barWidth: '7px',
    // showBackground: true,
    backgroundStyle: {
      color: 'rgba(220, 220, 220, 0.4)',
      barBorderRadius: [30, 30, 30, 30] //圆角大小
    },    
    label: {
      show: true,
      position: 'right', //每一条的数据位置
      color: '#fff'
    },
    itemStyle: {
      normal: {
        color: (params) => {
          // const colors = ['#4956ff', '#2d82ff', '#56F1FF', '#FF9B26', '#146CFF'];
          // return colors[params.dataIndex];
          const myColor = ['#eb2100', '#eb3600', '#d0570e', '#d0a00e', '#34da62', '#00e9db', '#00c0e9', '#0096f3', '#33CCFF', '#33FFCC'];
          const num = myColor.length;
          return myColor[params.dataIndex % num];
        }, //每个数据的颜色
        barBorderRadius: [30, 30, 30, 30], //圆角大小
        shadowBlur: 10,
        shadowColor: 'rgba(0, 103, 255, 0.2)',
        shadowOffsetX: -5,
        shadowOffsetY: 5,
      },
    },
    data: [{
      value: 10
    }, {
      value: 24
    }, {
      value: 32
    }, {
      value: 38
    }, {
      value: 42
    }, {
      value: 55
    }, {
      value: 68
    }, {
      value: 72
    }, {
      value: 79
    }, {
      value: 83
    }, {
      value: 94
    }, {
      value: 103
    }, {
      value: 223
    }, {
      value: 253
    }, {
      value: 354
    }, {
      value: 596
    }, {
      value: 653
    }, {
      value: 942
    }, {
      value: 963
    }, {
      value: 1269
    }]
  }]
};
